import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=20d60e88&lang=pug"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=20d60e88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports